function r(e, n, o = void 0) {
  return {
    src: e,
    alt: n,
    title: o
  };
}
export {
  r as newImageModel
};
//# sourceMappingURL=image-model.js.map
